export default __webpack_public_path__ + "static/i_spape-b11ca69d4159d93806e0596aaa5fc34a.jpg";